<div class="court-slots-container">
  <app-lead-time-notice [leadTimeMinutes]="leadTimeMinutes" />

  <!-- Loading state -->
  @if (internalLoading) {
    <div class="loading-indicator">
      Lade verfügbare Zeiten...
    </div>
  }

  <!-- Error state -->
  @if (!internalLoading && errorMessage) {
    <div class="error-message">
      {{ errorMessage }}
    </div>
  }

  <!-- No slots message -->
  @if (!internalLoading && !errorMessage && !slots.length) {
    <div class="no-slots-message">
      Keine verfügbaren Zeiten für diesen Tag oder diese Dauer
    </div>
  }

  <!-- Slots grid -->
  @if (!internalLoading && slots.length > 0) {
    <div class="slots-grid">
      @for (slot of slots; track slot.startTimeUtc) {
        @let status = getSlotStatus(slot);
        @let outOfLeadTime = isOutOfLeadTime(slot);
        <div
          class="slot-box"
          [class.available]="status === 'available' && !slot.isPast && !outOfLeadTime"
          [class.reserved]="status === 'reserved'"
          [class.booked]="status === 'booked'"
          [class.blocked]="status === 'blocked'"
          [class.course-available]="status === 'course_available' && !slot.isPast"
          [class.course-full]="status === 'course_full' && !slot.isPast"
          [class.has-mixed-status]="shouldShowMixedStatusStyling(slot)"
          [class.past]="slot.isPast"
          [class.out-of-lead-time]="outOfLeadTime && !slot.isPast"
          [class.selected]="isSelected(slot)"
          [attr.title]="outOfLeadTime ? leadTimeTooltip() : courseTooltip(slot)"
          (click)="selectSlot(slot)">
          <!-- Time -->
          <div class="time-range">
            <span class="time">{{ formatTime(slot.startTimeUtc) }}</span>
          </div>
        </div>
      }
    </div>
  }

  <!-- Legend for the pill states (per design) -->
  @if (!internalLoading && slots.length > 0) {
    <div class="slot-legend">
      <span class="legend-item">
        <span class="legend-swatch legend-free"></span>Frei
      </span>
      <span class="legend-item">
        <span class="legend-swatch legend-course"></span>Kurs verfügbar
      </span>
      <span class="legend-item">
        <span class="legend-swatch legend-booked"></span>Belegt
      </span>
      <span class="legend-item">
        <span class="legend-swatch legend-blocked"></span>Gesperrt
      </span>
    </div>
  }
</div>
